<template>
  <div
    style="
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      margin-top: 32px;
      padding-bottom: 100px;
    "
  >
    <div
      style="
        width: 1200px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
		padding-top: 30px;
      "
    >
      <div style="width: 100%; height: auto; margin-top: 30px" class="flex">
        <div style="width: 270px; margin-right: 24px">
          <div
            style="
              width: 100%;
              height: 50px;
              background: #fafafa;
              border: 1px solid #dddddd;
            "
            class="flex align-center justify-center"
          >
            {{ $t("h.AskToBuy.Category") }}
          </div>
          <div
            @click="classifyChange(index)"
            v-for="(item, index) in classifyData"
            :key="index"
            :style="
              item.select
                ? 'background: #d7000F;color: #FFFFFF;border-left: 1px solid #DDDDDD;border-right: 1px solid #DDDDDD;border-bottom: 1px solid #DDDDDD;'
                : 'border-left: 1px solid #DDDDDD;border-right: 1px solid #DDDDDD;border-bottom: 1px solid #DDDDDD;color: #666666;'
            "
            style="
              width: 100%;
              min-height: 50px;
              font-size: 16px;
              border-radius: 1px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              padding: 8px 12px;
              box-sizing: border-box;
            "
          >
            {{ $t(`h.AskToBuy.classify.${item.value || 'all'}`) }}
          </div>
        </div>
        <div style="width: 906px">
          <div
            style="
              width: 100%;
              height: 42px;
              background: #fafafa;
              padding: 0 24px;
            "
            class="flex align-center justify-between"
          >
            <div class="flex align-center">
              <div style="font-size: 14px; color: #444444; padding-right: 9px">
                {{ $t("h.AskToBuy.SearchResults") }}：
              </div>
              <div style="font-size: 14px" class="flex">
                <div>
                <span place="total" style="color: #d7000F; padding: 0 4px">{{
                    total
                  }}</span>
                  {{ $t("h.AskToBuy.results") }}
                </div>
              </div>
            </div>
            <div v-if="keyword" @click="resetBtn" style="cursor:pointer;">{{ $t("h.AskToBuy.reset") }}</div>
          </div>
          <div style="font-size: 30px; color: #212121; padding: 20px">
            {{ $t("h.AskToBuy.BuyerPurchasingInformation") }}
          </div>
          <div v-if="listData && listData.length">
            <div
              v-for="(item, index) in listData"
              :key="index"
              style="
                width: 100%;
                height: auto;
                border: 1px solid #d8d8d8;
                border-radius: 1px;
                margin-bottom: 20px;
              "
            >
              <div style="padding: 24px">
                <div class="flex justify-between">
                  <div class="flex align-center">
                    <div style="width: 130px; font-size: 14px; color: #8d8d8d">
                      AN024
                    </div>
                    <div style="font-size: 14px; color: #212121">
                      {{ $t("h.AskToBuy.BuyersFrom") }}
                    </div>
                    <div
                      style="
                        background: #fae7e7;
                        border-radius: 3px;
                        font-size: 12px;
                        color: #f23c3c;
                        padding: 0 6px;
                        margin-left: 10px;
                      "
                    >
                      {{ translateType(item.type_dictText) }}
                    </div>
                  </div>
                  <div style="font-size: 14px; color: #8d8d8d">
                    {{ $t("h.AskToBuy.ReleaseDate") }}：{{ item.createTime }}
                  </div>
                </div>
                <div class="flex align-center" style="margin-top: 12px">
                  <div style="width: 130px; font-size: 14px; color: #8d8d8d">
                    {{ $t("h.AskToBuy.PurchaseProducts") }}：
                  </div>
                  <div style="font-size: 14px; color: #212121">
                    {{ translatePostsClassify(item.postsClassify_dictText) }}
                  </div>
                </div>
                <div
                  class="flex"
                  style="margin-top: 12px; align-items: flex-start"
                >
                  <div style="width: 130px; font-size: 14px; color: #8d8d8d">
                    {{ $t("h.AskToBuy.PurchaseDetails") }}：
                  </div>
                  <div style="font-size: 14px; color: #212121; width: 425px">
                    {{ item.content }}
                  </div>
                </div>
                <div class="flex align-center" style="margin-top: 12px">
                  <div style="width: 130px; font-size: 14px; color: #8d8d8d">
                    {{ $t("h.AskToBuy.Quantity") }}：
                  </div>
                  <div style="font-size: 14px; color: #212121">
                    {{ item.postsNumber }}
                  </div>
                </div>
              </div>
              <div
                style="
                  background: #fafafa;
                  border-radius: 1px;
                  height: 60px;
                  width: 100%;
                  padding: 0 24px;
                "
                class="flex align-center justify-between"
              >
                <div>
                  <span
                    style="font-size: 16px; color: #d7000F; padding-right: 2px"
                    >{{ item.countNumber || 0 }}</span
                  >
                  <span style="font-size: 16px; color: #000000">
                    {{ $t("h.AskToBuy.SuppliersHaveAppliedForMatching") }}
                  </span>
                </div>
                <div class="flex align-center">
                  <a-button
                    @click="contactBtn(item.id)"
                    style="
                      background: #d7000F;
                      border-radius: 4px;
                      border: none;
                      font-size: 14px;
                      color: #ffffff;
                    "
                  >
                    {{ $t("h.AskToBuy.ContactBuyer") }}
                  </a-button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="flex align-center justify-center"
            style="
              width: 100%;
              height: 500px;
              border: 1px solid #d8d8d8;
              border-radius: 1px;
              margin-bottom: 20px;
              color: #cccccc;
            "
          >
            {{ $t("h.AskToBuy.noData") }}
          </div>

          <div v-if="total" style="display: flex; justify-content: flex-end">
            <a-config-provider :locale="locale">
              <a-pagination class="myPagination"
                :pageSize="params.pageSize"
                @change="pageChange"
                :total="total"
              />
            </a-config-provider>
          </div>
        </div>
      </div>

      <a-modal
        :title="$t('h.AskToBuy.ContactBuyer')"
        :visible="contactDialog"
        :closable="false"
      >
        <a-textarea
          v-model="contactContent"
          :placeholder="$t('h.AskToBuy.PleaseEnterYourContent')"
          :auto-size="{ minRows: 5 }"
        />
        <template slot="footer">
          <a-button @click="confirmBtn" type="danger">
            {{ $t("h.AskToBuy.confirm") }}
          </a-button>
          <a-button @click="contactDialog = false" key="back">
            {{ $t("h.AskToBuy.cancel") }}
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.min.css";
import { addConsultations, allPosts } from "@/assets/api";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import enUS from "ant-design-vue/lib/locale-provider/en_US";

export default {
  name: "Search",
  data() {
    return {
      locale: zhCN,
      selectedValue: "供应商",
      keyword: null,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      listData: [],
      options: [
        {
          label: "供应商",
          value: "供应商",
        },
        {
          label: "产品",
          value: "产品",
        },
      ],
      classifyData: [
        {
          select: true,
          value: "",
        },
        {
          select: false,
          value: '1',
        },
        {
          select: false,
          value: '2',
        },
        {
          select: false,
          value: '3',
        },
        {
          select: false,
          value: '4',
        },
        {
          select: false,
          value: '5',
        },
        {
          select: false,
          value: '6',
        },
        {
          select: false,
          value: '7',
        }
      ],
      typeQuery: null,
      contactDialog: false,
      contactContent: null,
      contactId: null,
      isLogin: null,
    };
  },
  watch: {
    '$i18n.locale': function(val) {
      this.locale = val === 'zh' ? zhCN : enUS;
    }
  },
  created() {
    this.keyword = this.$route.query.keyword;
    this.getList();
    this.isLogin = localStorage.getItem("token");
    this.locale = this.$i18n.locale === 'zh' ? zhCN : enUS;
  },
  methods: {
    resetBtn(){
      this.keyword = null
      this.getList()
    },
    contactBtn(record) {
      this.contactId = record;
      this.contactContent = null;
      this.contactDialog = true;
    },
    confirmBtn() {
      if (!this.isLogin) {
        this.$message.error(this.$t("h.AskToBuy.PleaseVisitorLoginFirst"));
        return false;
      } else if (!this.contactContent || this.contactContent.length > 200) {
        this.$message.error(this.$t("h.AskToBuy.maxLength"));
        return false;
      } else {
        this.loading = true;
        this.$axios
          .post(addConsultations, {
            title: this.contactContent,
            type: 2,
            postId: this.contactId,
          })
          .then((res) => {
            if (res.data.success) {
              this.loading = false;
              this.$message.success(res.data.message);
              this.dialogOpen = false;
              this.contactDialog = null;
              this.getList();
            } else {
              this.loading = false;
              this.$message.error(res.data.message);
            }
          });
      }
    },
    pageChange(current, size) {
      this.params.pageNo = current;
      this.params.pageSize = size;
      this.getList();
    },
    getList() {
      this.$axios
        .get(allPosts, {
          params: {
            typeQuery: this.typeQuery,
            pageNo: this.params.pageNo,
            pageSize: this.params.pageSize,
            fixId: this.$route.query.id,
            keyword: this.keyword
          },
        })
        .then((res) => {
          if (res && res.data.success) {
            this.listData = res.data.result.records;
            this.total = res.data.result.total;
          }
        });
    },
    classifyChange(index) {
      this.typeQuery = this.classifyData[index].value;
      this.classifyData.forEach((item, i) => {
        item.select = index === i;
      });
      this.getList();
    },
    translatePostsClassify(text) {
      if (!text) return text;
      const classifyMap = {
        '全部': { zh: '全部', en: 'All' },
        '线缆线材生产与精加工机械': { zh: '线缆线材生产与精加工机械', en: 'Cable and wire production and finishing machinery' },
        '辅助加工': { zh: '辅助加工', en: 'Auxiliary processing' },
        '辅助加工材料': { zh: '辅助加工材料', en: 'Auxiliary processing materials' },
        '材料和特种电线电缆': { zh: '材料和特种电线电缆', en: 'Materials and special wires and cables' },
        '测控技术': { zh: '测控技术', en: 'Measurement and Control Technology' },
        '检测工程': { zh: '检测工程', en: 'Testing Engineering' },
        '相关领域': { zh: '相关领域', en: 'Related areas' },
        '原材料': { zh: '原材料', en: 'Raw Materials' },
        '机械设备': { zh: '机械设备', en: 'Equipment' },
        '半制品或制品': { zh: '半制品或制品', en: 'Semi-finished or finished products' },
        '其他生产解决方案': { zh: '其他生产解决方案', en: 'Other Production Solutions' }
      };
      const lang = this.$i18n.locale === 'en' ? 'en' : 'zh';
      return classifyMap[text] ? classifyMap[text][lang] : text;
    },
    translateType(text) {
      if (!text) return text;
      const typeMap = {
        '境外采购商': { zh: '境外采购商', en: 'Foreign Buyers' },
        '境内采购商': { zh: '境内采购商', en: 'Domestic Buyers' },
        '紧急需求': { zh: '紧急需求', en: 'Urgent Needs' }
      };
      const lang = this.$i18n.locale === 'en' ? 'en' : 'zh';
      return typeMap[text] ? typeMap[text][lang] : text;
    },
  },
};
</script>

<style scoped lang="scss">
a {
  color: #3da5ff;
  text-decoration: none;
  transition: color 0.3s ease; /* 添加颜色过渡效果 */
}

a:hover {
  color: #d7000F;
  text-decoration: underline;
}

a:visited {
  color: #3da5ff;
}

a:active {
  color: yellow;
}

::v-deep .ant-select-selection {
  height: 58px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .ant-select-arrow {
  right: 20px;
}

.icons {
  width: 1100px;
  height: auto;
  overflow: hidden;
}

.icons-item {
  width: 25%;
  height: 234px;
  margin: auto;
  float: left;
  overflow: hidden;
  padding: 6px;
}

.icons-item img {
  width: 100%;
  height: 100%;
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.swiper-pagination {
  /* 自定义分页器样式 */
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-footer {
  border-top: none;
}

::v-deep .ant-modal-body {
  padding: 0 24px;
}
.myPagination {
  ::v-deep .ant-pagination-item-active {
    border-color: #d7000F;
    background-color: #d7000F;

    a {
      color: #fff;
    }
  }
}
</style>
